(function AdzukiMyTripsLogin($, Adzuki)
{
    'use strict';

    const component = {
        emits : ['component-event'],
        inject: {
            $inject_loggedIn: {
                default: false
            },
            setLoggedIn: {
                default: () => undefined
            },
            openAlert: {
                default: () => undefined
            },
            onLoginSuccess: {
                default: null
            }
        },
        props: {
            allowsSignup: {
                type   : Boolean,
                default: true
            }
        },
        data() {
            return {
                baseUri  : Adzuki.base_uri,
                loginForm: {
                    email   : '',
                    password: '',
                },
                isLoading: false,
            };
        },
        methods: {
            async submitForm() {
                this.isLoading = true;
                const formData = new FormData();
                formData.append('email', this.loginForm.email);
                formData.append('password', this.loginForm.password);

                try {
                    const response = await fetch(this.baseUri + '/MyTrips/ajaxLogin', {
                        method: 'POST',
                        body  : formData,
                    });

                    const contentType = response.headers.get('content-type') || '';

                    if (!contentType.includes('application/json')) {
                        const body = await response.text();
                        console.error('Login returned non-JSON response:', body.substring(0, 200));
                        Adzuki.StatusMessage('error', 'Unable to sign in. Please try again.');
                        return;
                    }

                    const data = await response.json();

                    if (Number(data.code) !== 200) {
                        Adzuki.StatusMessage('error', data.message);
                        return;
                    }

                    if (typeof this.setLoggedIn === 'function') {
                        this.setLoggedIn(true);
                    }

                    if (typeof this.onLoginSuccess === 'function') {
                        this.onLoginSuccess();
                    } else {
                        this.$emit('component-event', { type: 'login' });
                    }
                } catch (error) {
                    console.error('Login error:', error);
                    Adzuki.StatusMessage('error', error);
                }
            }
        },
        template: `
          <div class="login-section">
            <div class="login">
              <p class="h4">Welcome back! Please sign in to your account.</p>
              <form @submit.prevent="submitForm">
                  <div class="fields">
                    <div class="form-group">
                      <label class="required">Email</label>
                      <input type="email" class="form-control" v-model="loginForm.email" required />
                    </div>
                    <div class="form-group">
                      <label class="required">Password</label>
                      <input type="password" class="form-control" v-model="loginForm.password" required />
                      <br>
                      <a :href="baseUri + '/MyTrips/forgotPassword'" class="forgot-password">Forgot password?</a>
                    </div>
                  </div>
                  <div class="actions">
                    <div class="form-group second-action">
                      <template v-if="isLoading">
                        <adzuki-loading :loader-type="'button'" :button-class="'btn btn-primary login-btn'"></adzuki-loading>
                      </template>
                      <template v-else>
                        <button type="submit" class="btn btn-primary login-btn">Sign In</button>
                      </template>
                      <template v-if="allowsSignup">
                        <a :href="baseUri + '/MyTrips/createAccount'" class="btn signup-btn">Sign Up</a>
                      </template>
                    </div>
                  </div>
              </form>
            </div>
            
            <div class="register" v-if="allowsSignup">
              <h4><strong>Don't have an account?</strong></h4>
              <h4>Click the "Sign Up" button above to request an account and access the following information!</h4>
              <div class="details">
                <ul>
                  <li>View Trip Itinerary</li>
                  <li>View Trip Balance</li>
                  <li>Access Trip Documents</li>
                  <li>Purchase Travel Insurance</li>
                  <li>
                    Download Free Mobile App from<br>
                    <a href="https://apps.apple.com/us/app/cruise-planners-mobile/id605469772" target="_blank">
                      <img :src="baseUri + '/images/Apple_App_Store_v02.png'" style="width: 108px; height: 32px;" />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.cruiseplanners.cruiseplannersmobile&hl=en_US" target="_blank">
                      <img :src="baseUri + '/images/Google_Play_v02.png'" style="width: 108px; height: 32px;" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
		`,
    };

    Adzuki.VueComponents.AdzukiMyTripsLogin = component;
}(jQuery, window.Adzuki || {}));
